export default "__VITE_ASSET__CO8ymU$Z__"